

export default abstract class RegexConstants {

    static readonly EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    static readonly NUMBER_TEXT_REGEX = /^[0-9]+$/
    static readonly LETTERS_NUMBERS_TEXT_REGEX = /^[a-zA-Z0-9]+$/

}